import EditableLabel from './EditableLabel';

export default EditableLabel;
